import { Box, Checkbox, FormControlLabel, Grid, Tab, Tabs } from "@mui/material";
import * as React from "react";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { Base } from "ui/Scripts/source/framework/base";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { ApplicationPermissionType, ConfirmationDialogResult, DefaultHandlerType, WhistleBlowChannelResourceType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { IWhistleBlowChannelEditItem } from "ui/Scripts/source/models/whistleBlowChannel/whistleBlowChannelEditItem";
import { IWhistleBlowChannelEditResourceItem, WhistleBlowChannelEditResourceItem, WhistleBlowChannelEditResourceItemSave } from "ui/Scripts/source/models/whistleBlowChannel/whistleBlowChannelEditResourceItem";
import { AppUtils } from "../../../framework/appUtils";
import * as store from "../../../framework/customStore";
import { SaveDataObj } from "../../../framework/saveData";
import * as whistleBlowService from "../../../models/services/whistleBlowService";
import { ISessionState } from "../../../models/session/sessionState";
import * as storeActions from "../../../models/store/storeActions";
import { IUnitDefaultHandlersNode } from "../../../models/unit/unitDefaultHandlersNode";
import { IUnitModuleNode } from "../../../models/unit/unitModuleNode";
import { IUnitNodePermissions } from "../../../models/unit/unitNodePermissions";
import { UserListItems } from "../../../models/user/userListItems";
import { DialogSettingsCard } from "../../framework/Container/DialogSettingsCard";
import { CkEditorDialog } from "../../framework/Dialog/Dialog";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { IPageNavMenuItem, PageNavMenuItems } from "../../framework/PageNav/PageNavMenuItems";
import { SearchField } from "../../framework/SearchField";
import { ModifyUserInfo } from "../../framework/User/ModifyUserInfo";
import { UnitDefaultHandlersSettings } from "../../unit/Unit/UnitDefaultHandlersSettings";
import { UnitModuleSettings } from "../../unit/Unit/UnitModuleSettings";
import { UnitPermissionSettings } from "../../unit/Unit/UnitPermissionSettings";
import { WhistleBlowCategoryList } from "../WhistleBlowCategoryList";
import { WhistleBlowChannelEditDialogUserList } from "../WhistleBlowChannelEditDialogUserList/WhistleBlowChannelEditDialogUserList";
import { UnitModuleSaveResult } from "source/models/unit/unitModuleSaveResult";
import { AppCkEditor } from "source/components/framework/AppCkEditor";

/* eslint-disable no-unused-vars */
export const enum WhistleBlowSettingsDialogMenuItem {
    General = "1",
    Admins = "2",
    Texts = "3",
    Infos = "4",
    Permissions = "5",
    Units = "6",
    Handlers = "7",
    Categories = "8",
}
/* eslint-enable no-unused-vars */

export interface IWhistleBlowSettingsDialogProp {
    sessionState: ISessionState;
    companyId: string;
    classes?: string;
    whistleBlowSettingsActions: IPageNavMenuItem[];
    unitModuleNode: IUnitModuleNode;
    unitDefaultHandlersNode: IUnitDefaultHandlersNode;
    unitNodePermissions: IUnitNodePermissions;
    validAdditionalPermissions?: number[]
    onRefreshSessionState: () => void;
    onOk: () => void;
    onCancel: (whistleBlowChannelDataWasModified: boolean, closeDialog: boolean) => void;
    onUnitModuleDialogOk: () => void;
    onUnitModuleDialogOpen: () => void;
    onUnitModuleDialogSave: (obj: any) => Promise<UnitModuleSaveResult>;
    onUnitModuleDialogCancel: (closeDialog: boolean) => void;
    onDefaultHandlersSave: (obj: any) => Promise<ApiSuccess>;
    onDefaultHandlersOk: () => void;
    onDefaultHandlersOpen: () => void;
    onDefaultHandlersCancel: (closeDialog: boolean) => void;
    onGetUserSelectListItems: (companyId: string, unitId: string, handlerType: DefaultHandlerType, pageSize: number, page: number, filter: string,
        ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean,
        doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean) => Promise<UserListItems>;
    onPermissionsSave: (obj: any) => Promise<ApiSuccess>;
    onPermissionsOk: () => void;
    onPermissionsOpen: () => Promise<void>;
    onPermissionsCancel: (closeDialog: boolean) => void;
}

export interface IWhistleBlowSettingsDialogState {
    dataId: number;
    activeMenuItem: WhistleBlowSettingsDialogMenuItem;
    activeResource: IWhistleBlowChannelEditResourceItem;
    isLoading: boolean;
    whistleBlowApplicationUrl: string;
    cultures: IIdTitle[];
    whistleBlowChannel: IWhistleBlowChannelEditItem;
    id: string;
    pageName: string;
    privacyPolicyUrl: string;
    adminUsers: IModifyUser[];
    resources: IWhistleBlowChannelEditResourceItem[];
    whistleBlowChannelDataWasModified: boolean;
    ckEditorDataId: number;
}

export class WhistleBlowSettingsDialog extends React.Component<IWhistleBlowSettingsDialogProp, IWhistleBlowSettingsDialogState> {
    private orgStateHash: string = "";
    private editor: any = null;
    private ckEditorContainerDiv: HTMLDivElement;
    private unitsRef;
    private permissionsRef;
    private handlersRef;

    constructor(props: IWhistleBlowSettingsDialogProp) {
        super(props);
        this.state = {
            dataId: 0,
            ckEditorDataId: 0,
            activeMenuItem: WhistleBlowSettingsDialogMenuItem.Units,
            activeResource: null,
            isLoading: false,
            whistleBlowApplicationUrl: "",
            cultures: [],
            whistleBlowChannel: null,
            id: "",
            pageName: "",
            privacyPolicyUrl: "",
            adminUsers: [],
            resources: [],
            whistleBlowChannelDataWasModified: false,
        };
        this.unitsRef = React.createRef();
        this.permissionsRef = React.createRef();
        this.handlersRef = React.createRef();
    }

    handleSetActiveWhistleBlowRespource = (activeResource: IWhistleBlowChannelEditResourceItem) => {
        this.setState({
            activeResource
        });
        this.setCkEditorContent(activeResource);
    };

    loadWhistleBlowChannel = async () => {
        const props = this.props;
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => whistleBlowService.getWhistleBlowChannelEdit(props.companyId), false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        const whistleBlowChannel = result.whistleBlowChannel;
        const state = {
            ...this.state,
            whistleBlowChannel,
            whistleBlowApplicationUrl: result.whistleBlowApplicationUrl,
            id: whistleBlowChannel.id,
            pageName: whistleBlowChannel.pageName,
            privacyPolicyUrl: whistleBlowChannel.privacyPolicyUrl,
            adminUsers: whistleBlowChannel.adminUsers,
            cultures: result.cultures,
            resources: WhistleBlowChannelEditResourceItem.sortWhistleBlowChannelEditResourceItems(result.resources, result.cultures),
        };
        const saveData = this.getSaveDataFromState(props, state);
        this.orgStateHash = saveData.hash;
        this.setState(state);
    };

    async componentDidMount(): Promise<void> {
        await this.props.onUnitModuleDialogOpen();
        this.loadWhistleBlowChannel();
    }

    componentWillUnmount(): void {
        this.destroyCkEditor();
    }

    async componentDidUpdate(prevProps: IWhistleBlowSettingsDialogProp, prevState: IWhistleBlowSettingsDialogState): Promise<void> {
        const props = this.props;
        const state = this.state;
        if (prevProps.companyId === props.companyId) return;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            if (!await this.saveToDb()) return;
        }
        await this.loadWhistleBlowChannel();
    }

    setCkEditorContent = (activeResource: IWhistleBlowChannelEditResourceItem) => {
        this.setState({ ckEditorDataId: this.state.ckEditorDataId + 1 });
        if (!this.editor || !activeResource) return;
        this.editor.setData(activeResource.content, { callback: this.editor.resetDirty });
        Base.setCkEditorStyles(this.ckEditorContainerDiv, false);
        this.setState({ ckEditorDataId: this.state.ckEditorDataId + 1 });
    };

    destroyCkEditor = () => {
        if (!this.editor) return;
        if (this.editor.destroy) {
            this.editor.destroy();
        }
        this.editor = null;
    };

    handleToggleActiveMenuItem = async (menuItem: WhistleBlowSettingsDialogMenuItem) => {
        const state = this.state;

        if (state.activeMenuItem === menuItem) return;
        if (state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Units) {
            const res = await this.unitsRef.current.handleCancel(false);
            if (!res) return;
        } else if (state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Permissions) {
            const res = await this.permissionsRef.current.handleCancel(false);
            if (!res) return;
        } else if (state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Handlers) {
            const res = await this.handlersRef.current.handleCancel(false);
            if (!res) return;
        } else {
            await this.handleCancel(false);
        }

        if (menuItem === WhistleBlowSettingsDialogMenuItem.Units) {
            await this.props.onUnitModuleDialogOpen();
        }

        if (menuItem === WhistleBlowSettingsDialogMenuItem.Handlers) {
            await this.props.onDefaultHandlersOpen();
        }
        
        if (menuItem === WhistleBlowSettingsDialogMenuItem.Permissions) {
            await this.props.onPermissionsOpen();
        }

        let activeResource: IWhistleBlowChannelEditResourceItem = null;
        if (menuItem === WhistleBlowSettingsDialogMenuItem.Texts || menuItem === WhistleBlowSettingsDialogMenuItem.Infos) {
            activeResource = state.resources.find(i => menuItem === WhistleBlowSettingsDialogMenuItem.Texts
                ? i.resourceType === WhistleBlowChannelResourceType.Text
                : i.resourceType === WhistleBlowChannelResourceType.Info);
        } else {
            this.destroyCkEditor();
        }
        this.setState({
            activeMenuItem: menuItem,
            activeResource
        });
        this.setCkEditorContent(activeResource);
    };

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "pageName") {
            this.setState({ pageName: value });
        } else if (name === "privacyPolicyUrl") {
            this.setState({ privacyPolicyUrl: value });
        }
    };

    // #region PageName
    handleTestPageName = () => {
        const state = this.state;
        if (!state.whistleBlowApplicationUrl || !state.pageName) return;
        window.open(state.whistleBlowApplicationUrl + state.pageName, "_blank");
    };
    // #endregion PageName

    // #region PrivacyPolicy
    handleTestPrivacyPolicyUrl = () => {
        const state = this.state;
        if (!state.privacyPolicyUrl) return;
        window.open(state.privacyPolicyUrl, "_blank");
    };
    // #endregion PrivacyPolicy

    // #region Resources
    handleCkEditorInstanceReady = (ev) => {
        this.editor = ev.editor;
        Base.setCkEditorStyles(this.ckEditorContainerDiv, false);
        // TODO: see why it causes re-render loop
        // this.setState({
        //     ckEditorDataId: this.state.ckEditorDataId + 1
        // });
    };

    handleCkEditorChange = (ev) => {
        const state = this.state;
        if (!state.activeResource) return;
        const value: string = ev.editor.getData();
        const resources = state.resources.slice(0);
        const resource = resources.find(i => i.id === state.activeResource.id);
        if (!resource) return;
        resource.content = value;
        this.setState({
            resources: WhistleBlowChannelEditResourceItem.sortWhistleBlowChannelEditResourceItems(resources, state.cultures)
        });
    };

    handleResourceActiveStateChange = (value: number) => {
        const state = this.state;
        if (!state.activeResource) return;
        const resources = state.resources.slice(0);
        const resource = resources.find(i => i.id === state.activeResource.id);
        if (!resource) return;
        resource.activeState = value;
        this.setState({
            resources: WhistleBlowChannelEditResourceItem.sortWhistleBlowChannelEditResourceItems(resources, state.cultures)
        });
    };
    // #endregion Resources

    // #region Admins
    handleUsersRemoved = (codes: string[]) => {
        if (!codes || codes.length < 1) return;
        this.setState({
            adminUsers: this.state.adminUsers.filter(i => codes.indexOf(i.code) < 0),
            whistleBlowChannelDataWasModified: true
        });
    };

    handleUsersAdded = (newAdminUsers: IModifyUser[]) => {
        if (!newAdminUsers || newAdminUsers.length < 1) return;
        this.setState({
            adminUsers: this.state.adminUsers.concat(newAdminUsers),
            whistleBlowChannelDataWasModified: true
        });
    };
    // #endregion Admins

    getSaveDataFromState = (props: IWhistleBlowSettingsDialogProp, state: IWhistleBlowSettingsDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("rowId", state.whistleBlowChannel.rowId);
        result.append("companyId", props.companyId);
        result.append("id", state.id);
        result.append("pageName", state.pageName);
        result.append("privacyPolicyUrl", state.privacyPolicyUrl);
        result.append("resources", state.resources.map(i => new WhistleBlowChannelEditResourceItemSave(i)));
        return result;
    };

    checkErrors = (): Promise<boolean> => {
        const props = this.props;
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (props.sessionState.isSuperAdmin && !state.pageName) {
                store.customStore.dispatch(storeActions.showErrorMessage(Translations.PageNameMustBeDefined));
                return resolve(false);
            }
            return resolve(true);
        });
    };

    saveToDb = async (): Promise<SaveSuccess> => {
        const props = this.props;
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors)) return null;
        const saveData = this.getSaveDataFromState(props, state);
        //Call server
        const result = await AppUtils.callService(() => whistleBlowService.saveWhistleBlowChannelEdit(saveData.obj));
        if (!result) return null;
        this.orgStateHash = saveData.hash;
        await this.loadWhistleBlowChannel();
        return result;
    };

    handleSave = async () => {
        const props = this.props;
        const result = await this.saveToDb();
        if (!result) return;
        props.onOk();
    };

    handleCancel = async (closeDialog: boolean) => {
        const props = this.props;
        const state = this.state;
        const newHash = this.getSaveDataFromState(props, state).hash;
        
        const cancelResult = await AppUtils.cancel(newHash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.handleSave();
        } else {
            if (newHash !== this.orgStateHash) {
                await this.loadWhistleBlowChannel();
            }
            props.onCancel(state.whistleBlowChannelDataWasModified, closeDialog);
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.whistleBlowChannel) return null;
        const isSuperAdmin = props.sessionState.isSuperAdmin;
        const activeResourceCulture = state.activeResource
            ? state.cultures.find(i => i.id === state.activeResource.cultureCode)
            : null;
        const textResourcesActive = state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Texts;
        const infoResourcesActive = state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Infos;
        return (
            <CkEditorDialog
                id="wb-channel-edit-dialog"
                dataId={state.dataId.toString(10)}
                title={Translations.Settings}
                maxWidth="lg"
                maxHeight="100%"
                onClose={() => this.handleCancel(true)}
                body={
                    <GridRow flexGrow={2}>
                        <Grid item sm={3}>
                            <PageNavMenuItems
                                activeId={state.activeMenuItem}
                                items={props.whistleBlowSettingsActions}
                                onToggleMenuItem={this.handleToggleActiveMenuItem}
                            />
                        </Grid>
                        <Grid item sm={9} display="flex" flexDirection="column" flexGrow={2}>
                            {state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.General &&
                                <DialogSettingsCard
                                    fitToContainerHeight
                                    title={Translations.BasicInformation}
                                    cardContent={
                                        <>
                                            <GridRow>
                                                {(isSuperAdmin
                                                    ? <Grid item sm={12}>
                                                        <FormField title={Translations.WhistleBlowUrl} required>
                                                            <SearchField
                                                                name="pageName"
                                                                value={state.pageName}
                                                                onChange={this.handleChange}
                                                                onSubmit={this.handleTestPageName}
                                                                buttonDisabled={!state.whistleBlowApplicationUrl || !state.pageName}
                                                                buttonTitle={Translations.Test}
                                                                helperText={(state.whistleBlowApplicationUrl ?? "") + (state.pageName ?? "")}
                                                            />
                                                        </FormField>
                                                    </Grid>
                                                    : <Grid item sm={12}>
                                                        <FormField title={`${Translations.WhistleBlowUrl} (${Translations.WhistleBlowUrlInfo.toLowerCase()})`}>
                                                            <SearchField
                                                                name="pageName"
                                                                value={(state.whistleBlowApplicationUrl ?? "") + (state.pageName ?? "")}
                                                                disabled
                                                                onSubmit={this.handleTestPageName}
                                                                buttonTitle={Translations.Test}
                                                                buttonDisabled={!state.whistleBlowApplicationUrl || !state.pageName}
                                                            />
                                                        </FormField>
                                                    </Grid>
                                                )}
                                            </GridRow>
                                            <FormField title={Translations.PrivacyPolicyUrl}>
                                                <SearchField name="privacyPolicyUrl" value={state.privacyPolicyUrl} onChange={this.handleChange} onSubmit={this.handleTestPrivacyPolicyUrl} buttonTitle={Translations.Test} maxLength={255} buttonDisabled={!state.privacyPolicyUrl} />
                                            </FormField>
                                            <GridRow>
                                                <Grid item sm={6}>
                                                    <FormField title={Translations.Modified}>
                                                        <ModifyUserInfo
                                                            modifyUser={state.whistleBlowChannel.modifyUser} />
                                                    </FormField>
                                                </Grid>
                                            </GridRow>
                                        </>
                                    }
                                />
                            }
                            {state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Admins &&
                                <WhistleBlowChannelEditDialogUserList
                                    sessionState={props.sessionState}
                                    whistleBlowChannelId={state.id}
                                    companyId={props.companyId}
                                    title={Translations.Admins}
                                    users={state.adminUsers}
                                    onRemoved={this.handleUsersRemoved}
                                    onAdded={this.handleUsersAdded}
                                    onRefreshSessionState={props.onRefreshSessionState}
                                />
                            }
                            <Box className={textResourcesActive || infoResourcesActive ? "" : "d-none"} height="100%">
                                <DialogSettingsCard
                                    fitToContainerHeight
                                    title={(textResourcesActive ? Translations.WhistleBlowFrontPage : Translations.WhistleBlowGuide)}
                                    cardContent={
                                        <>
                                            <Tabs value={activeResourceCulture?.id || "fi"} sx={{ margin: ".5rem 0" }}>
                                                {state.resources.filter(i => i.resourceType === (textResourcesActive ? WhistleBlowChannelResourceType.Text : WhistleBlowChannelResourceType.Info)).map((resource) => {
                                                    const culture = state.cultures.find(i => i.id === resource.cultureCode);
                                                    return <Tab
                                                        key={resource.id}
                                                        value={resource.cultureCode}
                                                        label={(culture?.title ?? resource.cultureCode) + (resource.activeState < 1 ? " (" + Translations.NotInUse.toLowerCase() + ")" : "")}
                                                        onClick={() => this.handleSetActiveWhistleBlowRespource(resource)}
                                                    />;
                                                })}
                                            </Tabs>
                                            {!!state.activeResource &&
                                                <FormControlLabel
                                                    label={Translations.InUse}
                                                    control={
                                                        <Checkbox
                                                            checked={state.activeResource.activeState > 0}
                                                            onChange={(_event, checked: boolean) => this.handleResourceActiveStateChange(checked ? 1 : 0)}
                                                        />
                                                    }
                                                />
                                            }
                                        </>
                                    }
                                    content={
                                        <AppCkEditor
                                            fitToContainerHeight
                                            value={state.activeResource?.content ?? ""}
                                            dataId={state.ckEditorDataId}
                                            height=""
                                            onInstanceReady={this.handleCkEditorInstanceReady}
                                            onChange={this.handleCkEditorChange}
                                        />
                                    }
                                />
                            </Box>
                            <Box display="flex" flexDirection="column" flexGrow={2}>
                                {state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Permissions && (
                                    <UnitPermissionSettings
                                        ref={this.permissionsRef}
                                        accessRightNoneTitle={Translations.AccessRightNone}
                                        accessRightReadTitle={Translations.AccessRightReadWhistleBlow}
                                        accessRightWriteTitle={Translations.AccessRightWriteWhistleBlow}
                                        additionalPermissionATitle={Translations.AdditionalPermissionAWhistleBlow}
                                        additionalPermissionBTitle={Translations.AdditionalPermissionBWhistleBlow}
                                        hideAllUsers={true}
                                        hideUserGroups={true}
                                        validAdditionalPermissions={props.validAdditionalPermissions}
                                        companyId={props.companyId}
                                        unitNodePermissions={props.unitNodePermissions}
                                        cardView={true}
                                        onSave={props.onPermissionsSave}
                                        onOk={props.onPermissionsOk}
                                        onCancel={props.onPermissionsCancel}
                                    />
                                )}
                                {(state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Units) && (
                                    <UnitModuleSettings
                                        ref={this.unitsRef}
                                        companyId={props.companyId}
                                        sessionState={props.sessionState}
                                        applicationPermissionType={ApplicationPermissionType.WhistleBlow}
                                        unitModuleNode={props.unitModuleNode}
                                        onCancel={props.onUnitModuleDialogCancel}
                                        onOk={props.onUnitModuleDialogOk}
                                        onSave={props.onUnitModuleDialogSave}
                                    />
                                )}
                                {state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Handlers && (
                                    <UnitDefaultHandlersSettings
                                        ref={this.handlersRef}
                                        companyId={props.companyId}
                                        unitNode={props.unitDefaultHandlersNode}
                                        onSave={props.onDefaultHandlersSave}
                                        onOk={props.onDefaultHandlersOk}
                                        onCancel={props.onDefaultHandlersCancel}
                                        onGetUserSelectListItems={props.onGetUserSelectListItems}
                                    />
                                )}
                                {state.activeMenuItem === WhistleBlowSettingsDialogMenuItem.Categories && (
                                    <WhistleBlowCategoryList
                                        companyId={props.companyId}
                                    />
                                )}
                            </Box>
                        </Grid>
                    </GridRow>
                }
                buttons={(state.activeMenuItem !== WhistleBlowSettingsDialogMenuItem.Units && state.activeMenuItem !== WhistleBlowSettingsDialogMenuItem.Permissions && state.activeMenuItem !== WhistleBlowSettingsDialogMenuItem.Handlers)
                    ? [
                        { title: Translations.Close, variant: "outlined", onClick: () => this.handleCancel(true) },
                        { title: Translations.Save, variant: "confirmation", onClick: (state.activeMenuItem !== WhistleBlowSettingsDialogMenuItem.Admins && state.activeMenuItem !== WhistleBlowSettingsDialogMenuItem.Categories) ? this.handleSave : null, disabled: this.getSaveDataFromState(props, state).hash === this.orgStateHash },
                    ]
                    : null}
            />
        );
    }
}